module.exports = __webpack_public_path__ + "img/aplicacao_pelicula.a75bcbfd.jpeg";